const state = {
  addSpinner: false,
};
export default {
  state,
};
